module.exports = __webpack_public_path__ + "img/dark-mud-decal-23.3aca07a7.png";